
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Phase III: Erkrankung`}</h3>
    <p>{`Am `}<strong parentName="p">{`Freitag`}</strong>{`, nach Ablauf der Inkubationszeit von meistens 5 bis 6 Tagen,
treten bei Ihnen die `}<strong parentName="p">{`ersten Symptome`}</strong>{` auf: Kopfschmerzen, leichter Husten und
Verlust des Geschmackssinns. Aus Vorsicht gehen Sie zum Arzt. `}<strong parentName="p">{`Der Test ist
positiv`}</strong>{`, und einige Stunden später werden Sie angewiesen, sich zu Hause in
strenge Isolation zu setzen. Alle Mitglieder Ihres Haushalts müssen sich
ebenfalls in Quarantäne begeben.`}</p>
    <p><strong parentName="p">{`Draussen dreht sich die Welt weiter, auch ohne Sie.`}</strong></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;